window.kentico = window.kentico || {}

window.kentico.updatableFormHelper = (function () {
  // Duration for which user must not type anything in order for the form to be submitted.
  const KEY_UP_DEBOUNCE_DURATION = 800

  const errorMessages = {
    en: 'We apologize, an error occurred on our side while handling your request. Please refresh and retry your request as it may have been temporary.',
    fr: 'Nous nous excusons, une erreur s\'est produite de notre c�t� lors du traitement de votre demande. Veuillez actualiser et r�essayer votre demande car elle pourrait �tre temporaire.',
    nl: 'Onze excuses, er is een fout opgetreden aan onze kant tijdens het verwerken van uw verzoek. Vernieuw en probeer uw verzoek opnieuw, omdat dit tijdelijk kan zijn.'
  }

  /**
     * Registers event listeners and updates the form upon changes of the form data.
     * @param {object} config Configuration object.
     * @param {string} config.formId ID of the form element.
     * @param {string} config.targetAttributeName Data attribute of element that is used to be replaced by HTML received from the server.
     * @param {string} config.unobservedAttributeName Data attribute which marks an input as not being observed for changes.
     */
  function registerEventListeners (config) {
    console.log(config)
    if (!config || !config.formId || !config.targetAttributeName || !config.unobservedAttributeName) {
      throw new Error('Invalid configuration passed.')
    }

    const writeableTypes = ['email', 'number', 'password', 'search', 'tel', 'text', 'time']

    const observedForm = document.getElementById(config.formId)
    if (!(observedForm && observedForm.getAttribute(config.targetAttributeName))) {
      return
    }

    for (let i = 0; i < observedForm.length; i++) {
      const observedFormElement = observedForm.elements[i]
      const handleElement = !observedFormElement.hasAttribute(config.unobservedAttributeName) &&
                observedFormElement.type !== 'submit'

      if (handleElement) {
        const isWriteableElement = (observedFormElement.tagName === 'INPUT' && writeableTypes.indexOf(observedFormElement.type) !== -1) || observedFormElement.tagName === 'TEXTAREA'

        if (isWriteableElement) {
          observedFormElement.previousValue = observedFormElement.value

          observedFormElement.addEventListener('keyup', debounce(function (e) {
            setTimeout(function () {
              if (!observedForm.updating && e.target.previousValue !== e.target.value) {
                observedForm.keyupUpdate = true
                const changedFieldName = extractFieldName(e.target)
                updateForm(observedForm, e.target, changedFieldName)
              }
            }, 0)
          }, KEY_UP_DEBOUNCE_DURATION))

          observedFormElement.addEventListener('blur', function (e) {
            setTimeout(function () {
              if (!observedForm.updating && e.target.previousValue !== e.target.value) {
                const changedFieldName = extractFieldName(e.target)
                updateForm(observedForm, e.relatedTarget, changedFieldName)
              }
            }, 0)
          })
        }

        observedFormElement.addEventListener('change', function (e) {
          setTimeout(function () {
            if (!observedForm.updating) {
              const changedFieldName = extractFieldName(e.target)
              updateForm(observedForm, null, changedFieldName)
            }
          }, 0)
        })
      }
    }
  }

  /**
     * Updates the form markup.
     * @param {HTMLElement} form Element of the form to update.
     * @param {Element} nextFocusElement Element which shout get focus after update.
     */
  function updateForm (form, nextFocusElement, changedFieldName) {
    if (!form) {
      return
    }

    // If form is not updatable then do nothing
    const elementIdSelector = form.getAttribute('data-ktc-ajax-update')
    if (!elementIdSelector) {
      return
    }

    form.querySelectorAll("input[type='submit']").forEach((item) => {
      item.setAttribute('onclick', 'return false;')
    })

    form.updating = true

    const formData = new FormData(form)
    formData.append('kentico_update_form', 'true')

    if (changedFieldName) {
      formData.append('kentico_changed_form_field_name', changedFieldName)
    }

    const focus = nextFocusElement || document.activeElement

    const onResponse = function (event) {
      if (!event.target.response.data) {
        let selectionEnd = null
        let selectionStart = null
        if (focus && (focus.type === 'text' || focus.type === 'search' || focus.type === 'password' || focus.type === 'tel' || focus.type === 'url')) {
          selectionStart = focus.selectionStart
          selectionEnd = focus.selectionEnd
        }

        const currentScrollPosition = window.scrollY
        const element = document.getElementById(elementIdSelector)

        renderMarkup(event.target.responseText, element)
        window.scrollTo(0, currentScrollPosition)

        if (focus.id) {
          const newInput = document.getElementById(focus.id)
          if (newInput) {
            newInput.focus()
            setCaretPosition(newInput, selectionStart, selectionEnd)
          }
        }
      }
      const parent = form.parentElement
      parent.dispatchEvent(new CustomEvent('form-updated', { bubbles: true }))
    }

    createRequest(form, formData, onResponse)
  }

  function submitForm (event) {
    event.preventDefault()
    const form = event.target
    form.validator.validateForm().then(function () {
      const formData = new FormData(form)
      const onResponse = function (event) {
        if (event.target.status !== 200) {
          console.log('Form error occurred')
          console.log(event)
          const replaceTargetId = form.getAttribute('data-ktc-ajax-update')
          const currentScrollPosition = window.scrollY
          const element = document.getElementById(replaceTargetId)
          const currentCulture = getCurrentCulture()
          const errorMessage = errorMessages[currentCulture] || errorMessages.en // Fallback to 'en' if culture not found
          renderMarkup(errorMessage, element)
          window.scrollTo(0, currentScrollPosition)
          return
        }

        const contentType = event.target.getResponseHeader('Content-Type')

        if (contentType.indexOf('application/json') === -1) {
          const replaceTargetId = form.getAttribute('data-ktc-ajax-update')
          const currentScrollPosition = window.scrollY
          const element = document.getElementById(replaceTargetId)
          renderMarkup(event.target.response, element)
          window.scrollTo(0, currentScrollPosition)

          const parent = form.parentElement
          if (parent) {
            parent.dispatchEvent(new CustomEvent('form-updated', { bubbles: true }))
          }
        } else {
          const json = JSON.parse(event.target.response)

          location.href = json.redirectTo
        }
      }

      createRequest(form, formData, onResponse)
    })
  }

  const renderMarkup = (markup, targetElement) => {
    targetElement.innerHTML = markup
    const scripts = targetElement.querySelectorAll('script')
    Array.prototype.forEach.call(scripts, (scriptElement) => {
      const parent = scriptElement.parentNode
      const temp = document.createElement('script');
      [...scriptElement.attributes].forEach((attr) => {
        temp.setAttribute(attr.name, attr.value)
      })

      temp.innerHTML = scriptElement.innerHTML
      parent.replaceChild(temp, scriptElement)
      scriptElement.remove()
    })
  }

  function createRequest (form, formData, onResponse) {
    const xhr = new XMLHttpRequest()

    xhr.addEventListener('load', onResponse)

    xhr.open('POST', form.action)
    xhr.send(formData)
  }

  /**
     * Sets the caret position.
     * @param {HTMLInputElement} input Input element in which the caret position should be set.
     * @param {number} selectionStart Selection start position.
     * @param {number} selectionEnd Selection end position.
     */
  function setCaretPosition (input, selectionStart, selectionEnd) {
    if (selectionStart === null && selectionEnd === null) {
      return
    }

    if (input.setSelectionRange) {
      input.setSelectionRange(selectionStart, selectionEnd)
    }
  }

  function debounce (func, wait, immediate) {
    let timeout

    return function () {
      const context = this
      const args = arguments

      const later = function () {
        timeout = null

        if (!immediate) {
          func.apply(context, args)
        }
      }

      const callNow = immediate && !timeout
      clearTimeout(timeout)
      timeout = setTimeout(later, wait || 200)

      if (callNow) {
        func.apply(context, args)
      }
    }
  }

  function extractFieldName (targetElement) {
    const fullName = targetElement.getAttribute('name') ?? ''
    const splitName = fullName.split('.')
    const secondToLast = splitName.length - 2
    return secondToLast >= 0 ? splitName[secondToLast] : ''
  }

  function getCurrentCulture () {
    const culture = document.documentElement.getAttribute('data-culture')
    if (!culture) {
      return 'en' // Fallback to 'en' if no culture is set
    }

    return culture.split('-')[0]
  }

  return {
    registerEventListeners,
    updateForm,
    submitForm
  }
}())
